import React, { useState, useRef } from "react";
import MarkIcon from '../assets/caseManagement/mark.svg';
import UnmarkIcon from '../assets/caseManagement/unmark.svg';
import CloseIcon from '../assets/caseManagement/close.svg';

function StatusDropdownButton({ props, handleCommandClick }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Dropdown options
  const options = [
    {
      label: props.status === "Assessed" ? "Unmark as Assessed" : "Mark as Assessed",
      icon: props.status === "Assessed" ? MarkIcon : UnmarkIcon,
      onClick: () => handleCommandClick({
        commandColumn: { type: "Assess" },
        rowData: props,
      }),
    },
    {
      label: props.status === "Closed" ? "Reopen Case" : "Close Case",
      icon: null, // You can use a suitable SVG/icon here
      onClick: () => handleCommandClick({
        commandColumn: { type: "Close" },
        rowData: props,
      }),
    },
  ];

  // Main button label/icon
  const mainLabel =
    props.status === "Closed"
      ? "Closed"
      : props.status === "Assessed"
      ? "Assessed"
      : "Open";
  const mainColor =
    props.status === "Closed"
      ? "bg-[#4B789B] hover:bg-[#3D6179]"
      : props.status === "Assessed"
      ? "bg-[#FBD332] hover:bg-[#D6B20F]"
      : "bg-[#FFA136] hover:bg-[#CC7C1A]";

  return (
    <div className="relative inline-block text-left w-[220px]" ref={dropdownRef}>
      <button
  onClick={() => setOpen((o) => !o)}
  className="flex items-center justify-between w-full px-4 py-2 bg-white border border-gray-300 rounded shadow-sm text-sm font-medium text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
  type="button"
>
  <span className="flex items-center">
    <span>Status</span>
  </span>
  <svg className="ml-2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M19 9l-7 7-7-7" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
</button>

      {open && (
        <div
          className="absolute z-10 mt-1 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 min-w-[200px] overflow-x-hidden"
          style={{ right: 0 }}
        >
          <div className="py-1">
            {options.map((option, idx) => {
              const isAssessedOption = option.label.includes("Assessed");
              const isChecked = props.status === "Assessed";
              const isCloseOption = option.label.includes("Close") || option.label.includes("Reopen");

              // Styling for selected "Assessed" option
              const selectedStyle = isAssessedOption && isChecked
                ? "bg-blue-900 text-white font-semibold"
                : isCloseOption
                ? "text-red-700 font-semibold"
                : "text-gray-800 font-semibold";

              // Icon for "Mark as Assessed" - Checkbox style
              const checkIcon = (
                <div className="flex-shrink-0 mr-2">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    readOnly
                    className="h-4 w-4 text-blue-900 border-gray-300 rounded focus:ring-blue-500"
                  />
                </div>
              );

              // Icon for "Close Case" - Using CloseIcon
              const lockIcon = (
                <img src={CloseIcon} alt="close" className="h-5 w-5 mr-2 flex-shrink-0" />
              );

              // Hover style: only apply if not selected
              const hoverStyle = isAssessedOption && isChecked
                ? ""
                : "hover:bg-gray-100";

              return (
                <button
                  key={idx}
                  className={`flex items-center w-full px-4 py-2 text-sm whitespace-nowrap rounded transition ${selectedStyle} ${hoverStyle}`}
                  onClick={() => {
                    option.onClick();
                    setOpen(false);
                  }}
                  tabIndex={0}
                >
                  {isAssessedOption
                    ? checkIcon
                    : isCloseOption
                    ? lockIcon
                    : null}
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default StatusDropdownButton;